// src/store/collection/collectionSelectors.ts
import type { CollectionNode } from "src/types/collection/collectionTypes";
import { useCollectionStore } from "./collectionStore";

export type CollectionStoreState = ReturnType<typeof useCollectionStore.getState>;

export const selectCollectionQuery = (s: CollectionStoreState) => s.query;
export const selectCollectionPageData = (s: CollectionStoreState) => s.pageData;
export const selectCollectionLoading = (s: CollectionStoreState) => s.loading;
export const selectCollectionError = (s: CollectionStoreState) => s.error;
export const selectExpandedIds = (s: CollectionStoreState) => s.expandedIds;

export type CollectionTableRow = {
  node: CollectionNode;
  level: number;
  hasChildren: boolean;
  childrenCount: number;
  isExpanded: boolean;
};

export const buildVisibleRows = (
  roots: CollectionNode[],
  expandedIds: Record<number, boolean>
): CollectionTableRow[] => {
  const rows: CollectionTableRow[] = [];

  const walk = (nodes: CollectionNode[], level: number) => {
    nodes.forEach((node) => {
      const hasChildren = !!node.children?.length;
      const isExpanded = !!expandedIds[node.collectionId];

      rows.push({
        node,
        level,
        hasChildren,
        childrenCount: node.children?.length || 0,
        isExpanded,
      });

      if (hasChildren && isExpanded) walk(node.children, level + 1);
    });
  };

  walk(roots, 0);
  return rows;
};
